<template lang="pug">
  span
    div.color-picker-container(
      v-if="!isEditing"
      :class="{'data-cell': isDataCell}"
    )
      v-swatches(
        :value.sync="value"
        disabled
        :trigger-style="colorTriggerStyle"
      )
    div.color-picker-container(
      v-else
      :class="{'data-cell': isDataCell}"
    )
      v-swatches.editable(
        :value.sync="value"
        show-fallback
        popover-y="bottom"
        swatch-size="30"
        fallback-input-type="color"
        fallback-ok-text="SELECT"
        :close-on-select="closeOnSelect"
        :trigger-style="colorTriggerStyle"
        :fallback-input-class="colorInputStyle"
        @close="handleInput"
      )
        slot(name="trigger" slot="trigger")
</template>

<script>
import VSwatches from 'vue-swatches';

export default {
  name: 'EditableColorPicker',
  components: {
    VSwatches,
  },
  props: {
    value: String,
    isEditing: Boolean,
    isDataCell: Boolean,
    closeOnSelect: Boolean,
  },
  data() {
    return {
      colorTriggerStyle: {
        width: '35px',
        height: '35px',
        padding: 0,
      },
      colorInputStyle: {
        padding: 0,
        marging: 0,
      },
    };
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
  },
}
</script>

<style lang="scss" scoped>
.color-picker-container {
  &.data-cell {
    position: absolute;
    margin-top: -5px;
  
    .editable /deep/ .vue-swatches__trigger__wrapper {
      border: 2px solid gray;
      padding: 3px;
      border-radius: 5px;
    }
  }

  /deep/ .vue-swatches__fallback__wrapper {
    display: flex;

    input {
      border: none;
      padding: 0;
      height: 30px;
      cursor: pointer;
    }

    input::-webkit-color-swatch {
      border-radius: 2px;
      border: 1px solid gray;
    }
    input::-moz-color-swatch {
      border-radius: 2px;
      border: 1px solid gray;
    }
  }
}
</style>